import React, { useRef, useState } from 'react';

import { SplitButton } from 'primereact/splitbutton';
import { Dropdown } from 'primereact/dropdown';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { ModelOfMaintanenceReport } from 'src/database';

import { useListCategoriesController } from 'src/controllers/Category/ListCategoriesController';
import LoadingScreen from 'src/components/LoadingScreen';
import { useMaintanenceReportsController } from 'src/controllers/DataReports/Maintanence/MaintanenceReports';
import { useListEspecieController } from 'src/controllers/Especies/ListEspecieController';

const MaintanenceReport: React.FC = () => {
  const { getEspecieListController } = useListEspecieController();
  const { getCategoryListController } = useListCategoriesController();
  const { getMaintanenceReport, handleMaintanenceReport } = useMaintanenceReportsController();

  const [vehiclesFiltered, setVehiclesFiltered] = useState<ModelOfMaintanenceReport[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [specieFilter, setSpecieFilter] = useState<string | null>(null);

  const species = getEspecieListController.EspecieData.map((specie) => {
    return specie.DESCRICAO;
  });
  const categorys = getCategoryListController.categoriesData.map((category) => {
    return category.DESCRICAO;
  });

  const dataTable: any = useRef(null);

  const exportCSV = () => {
    dataTable.current.exportCSV();
  }

  const exportItems = [
    {
      label: 'Exportar PDF',
      icon: 'pi pi-upload',
      command: () => { handleMaintanenceReport.generateMaintanenceReport(vehiclesFiltered) }
    },
    {
      label: 'Exportar CSV',
      icon: 'pi pi-upload',
      command: exportCSV
    }
  ];

  const handleFilter = (vehicleData: ModelOfMaintanenceReport[]) => {
    let filterObj = {
      'DESCRICAO_CATEGORIA': categoryFilter || '',
      'DESCRICAO_ESPECIE': specieFilter || ''
    };

    const filterKeys = Object.keys(filterObj);
    const filterValues = Object.values(filterObj);

    return vehicleData.filter((item: any) => {
      return filterKeys.every((value, eachKey) => {
        if (!filterValues[eachKey]) {
          return true;
        }
        return filterValues[eachKey]?.toString().includes(item[value]);
      });
    });
  };

  if (getMaintanenceReport.loading) {
    return <LoadingScreen />
  }

  return (
    <div>
      <div style={{ height: '100%' }} className="card p-align-center p-justify-center">
        <form className="p-grid p-fluid">
          <div className="p-field p-col-12 p-md-4">
            <label htmlFor="categoria" >Categoria</label>
            <Dropdown id="categoria"
              value={categoryFilter} showClear
              placeholder="Selecionar categoria"
              onChange={(e) => {
                (e.value ?
                  setCategoryFilter(e.value)
                  : setCategoryFilter(''))
              }}
              options={categorys}
            />
          </div>

          <div className="p-field p-col-12 p-md-4">
            <label htmlFor="especie" >Espécie</label>
            <Dropdown id="especie"
              value={specieFilter} showClear
              placeholder="Selecionar espécie"
              onChange={(e) => {
                (e.value ?
                  setSpecieFilter(e.value)
                  : setSpecieFilter(''))
              }}
              options={species}
            />
          </div>

          <div className="p-field p-col-12 p-md-4">
            <label>Para filtrar dados clique aqui</label>
            <SplitButton
              model={exportItems}
              icon="pi pi-search"
              label="Exibir relatório"
              onClick={() => setVehiclesFiltered(handleFilter(getMaintanenceReport.maintanenceReportData))} />
          </div>
        </form>
      </div>

      <ReportsComponent tableRef={dataTable} vehicleData={vehiclesFiltered} />
    </div>
  )
}

interface VehicleDataProps {
  vehicleData: ModelOfMaintanenceReport[];
  tableRef: any;
}

const ReportsComponent: React.FC<VehicleDataProps> = ({ vehicleData, tableRef }) => {

  const tableHeader = (
    <div className="table-header p-grid p-d-flex p-jc-between">
      <h5 className="p-m-0">Relatório de Manutenções</h5>
    </div>
  );

  const HEADER_VEICULO_MODELO = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">MODELO</span>
        {rowData.VEICULO_MODELO}
      </React.Fragment>
    );
  }

  const HEADER_PLACA = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">PLACA</span>
        {rowData.PLACA}
      </React.Fragment>
    );
  }

  const HEADER_CUSTO = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">CUSTO (R$)</span>
        {`R$ ${rowData.CUSTO}`}
      </React.Fragment>
    );
  }

  const HEADER_TEMPOMEDIO = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">TEMPO MÉDIO EM OFICINA</span>
        {`${rowData.TEMPOMEDIO} Horas / Visita`}
      </React.Fragment>
    );
  }

  const HEADER_TOTALMANUTENCOES = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">TOTAL MANUTENÇÕES</span>
        {rowData.RECORRENCIA}
      </React.Fragment>
    );
  }

  const HEADER_FREQUENCIA = (rowData: ModelOfMaintanenceReport) => {
    return (
      <React.Fragment>
        <span className="left-header">FREQUÊNCIA</span>
        {`${rowData.FREQUENCIA} %`}
      </React.Fragment>
    );
  }

  return (
    <div className="p-card p-p-4">
      <DataTable ref={tableRef}
        header={tableHeader}
        className="responsive-table p-datatable-sm"
        dataKey="PLACA" autoLayout
        value={vehicleData}
      >
        <Column field="VEICULO_MODELO" header="MODELO" body={HEADER_VEICULO_MODELO}></Column>
        <Column field="PLACA" header="PLACA" body={HEADER_PLACA}></Column>
        <Column field="CUSTO" header="CUSTO (R$)" body={HEADER_CUSTO}></Column>
        <Column field="TEMPOMEDIO" header="TEMPO MÉDIO EM OFICINA" body={HEADER_TEMPOMEDIO}></Column>
        <Column field="RECORRENCIA" header="TOTAL MANUTENÇÕES" body={HEADER_TOTALMANUTENCOES}></Column>
        <Column field="FREQUENCIA" header="FREQUÊNCIA (%)" body={HEADER_FREQUENCIA}></Column>
      </DataTable>
    </div>
  );
}

export default MaintanenceReport;